import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
//import store from "../..";

const state = {
  rules: [],
  actions: [],
  rule: {},
  pagination: {},
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
};
const getters = {
  rulesListGet: (state) => state.rules,
  ruleGet: (state) => state.rule,
  actionsListGet: (state) => state.actions,
};
const actions = {
  async getRules({ commit }) {
    await service.getFun(`rules`).then(
      (response) => {
        let result = response.data;
        commit("setRules", result);
        console.log("rules", result);
      },
      (error) => {
        console.log(error);
      }
    );
  },
  getRuleById({ commit }, payload) {
    service.getFun(`rules/${payload}`).then(
      (obj) => {
        var result = obj.data;
        commit("getRuleId", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  async getActions({ commit }) {
    const res = await service.getFun(`actions`);
    if (res) {
      let result = res.data;
      console.log("Actions===", result);
      commit("setActions", result);
    }
  },
  addRule({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `rules`, null, {
        action: "getRules",
      })
      .then(
        (result) => {
          commit("addRuleStatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("rules..." + error);
          toastError(error);
        }
      );
  },
  editRule({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `rules/${payload.id}`, null, {
        action: "getRules",
      })
      .then(
        (result) => {
          if (result) {
            commit("editRuleStatus", result.success);
            toast(result.message);
          } else {
            commit("editRuleStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  async deleteRule({ commit }, payload) {
    console.log(payload, "payload");
    const result = await service.deleteFun(`rules/${payload?.payload}`, {
      action: "getRules",
    });
    if (result) {
      commit("deleteRuleStatus", result?.success);
      toast(result?.message);
    }
  },
};
const mutations = {
  setRules(state, rules) {
    state.rules = rules;
  },
  setActions(state, payload) {
    state.actions = payload;
  },
  addRuleStatus(state, Status) {
    state.addStatus = Status;
  },
  editRuleStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteRuleStatus(state, Status) {
    state.deleteStatus = Status;
  },
  getRuleById(state, rule) {
    state.rule = rule;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
